document.addEventListener('DOMContentLoaded', () => {
  const hero = document.querySelector('.hero');
  const stickyNav = document.querySelector('.sticky-nav');
  const heroBottom = hero.offsetTop + hero.offsetHeight;

  window.addEventListener('scroll', () => {
    if (window.scrollY >= heroBottom) {
      stickyNav.classList.add('visible');
    } else {
      stickyNav.classList.remove('visible');
    }
  }, { passive: true });
});
